import { render, staticRenderFns } from "./ForMediaProviders.vue?vue&type=template&id=1f6a5bba&scoped=true&lang=pug&"
import script from "./ForMediaProviders.vue?vue&type=script&lang=ts&"
export * from "./ForMediaProviders.vue?vue&type=script&lang=ts&"
import style0 from "./ForMediaProviders.vue?vue&type=style&index=0&id=1f6a5bba&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6a5bba",
  null
  
)

export default component.exports